import { z } from '@hono/zod-openapi'
import { benefitApplicationsTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertBenefitApplication = z.infer<typeof zInsertBenefitApplication>
export type SelectBenefitApplication = z.infer<typeof zSelectBenefitApplication>
export type UpdateBenefitApplication = z.infer<typeof zUpdateBenefitApplication>
export type QueryBenefitApplications = z.infer<typeof zQueryBenefitApplications>
export type ColumnsOfBenefitApplicationsTable =
    keyof typeof benefitApplicationsTable._.columns

export const zSelectBenefitApplication = createSelectSchema(
    benefitApplicationsTable,
)
export const zInsertBenefitApplication = createInsertSchema(
    benefitApplicationsTable,
).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateBenefitApplication = zInsertBenefitApplication.partial()
export const zQueryBenefitApplications = zInsertBenefitApplication
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
